import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-6 md:px-10 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-label font-semibold tracking-widest uppercase text-accent-600 bg-accent-100 px-4 py-1.5 rounded-full">
            探索分类
          </span>
          <h2 className="mt-4 text-2xl md:text-3xl font-heading font-semibold text-foreground-950">
            全方位抗衰知识体系
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            从护肤到饮食，从运动到心理，六大维度构建完整的科学抗衰方案
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center text-center p-5 md:p-6 bg-background-100 rounded-xl hover:bg-accent-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-accent-100 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl text-accent-600`}></i>
              </div>
              <h3 className="mt-3 text-sm font-semibold text-foreground-800 group-hover:text-accent-700 transition-colors whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="mt-1.5 text-xs text-foreground-400 leading-relaxed line-clamp-2">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}